

import React, { useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CardTable2";
// import Dropdown from "../../../../components/AdminDropdown/Dropdown";

function RiderReport() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },

    {
      header: "Date",
      accessorKey: "Date",
    },
    {
      header: "Reference",
      accessorKey: "Reference",
    },
    {
      header: "Name",
      accessorKey: "Name",
    },
    {
      header: "Phone",
      accessorKey: "Phone",
    },
    {
      header: "G. Total",
      accessorKey: "G. Total",
    },
    {
      header: "Order status",
      accessorKey: "Order status",
    },
    {
      header: "Payment Status",
      accessorKey: "Payment Status",
    },
    
  ]);
  const [data] = useState([]);
  const [buttonDataa] = useState([
    {
      buttonText: "Submit",
    },
  ]);

  const [selectButton] = useState([
    {
      placeholder: "Rider",
    },
  ]);
  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={"Rider Report"}
        buttonDataa={buttonDataa}
        selectButton={selectButton}
      />
    </main>
  );
}

export default RiderReport;
